import styled from 'styled-components'
import { MediaBreakPointUp } from '~/theme'

export const InputGroup = styled.div`
  margin: 18px 0;
  width: 100%;
`

export const InputWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.borderInput};
  border-radius: 56px;
  display: flex;
  flex-direction: row;
  height: 64px;
  justify-content: space-between;
  padding: 3px;
  position: relative;
  width: 100%;
`

export const InputRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 20px;
  flex: 1;
  overflow: hidden;
`

export const Input = styled.input`
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
  outline: none;
  text-align: right;
  width: 100%;
  padding-right: 0;
  ::placeholder {
    color: ${({ theme }) => theme.colors.textPlaceholder};
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  -moz-appearance: textfield;
`

export const InputHelpText = styled.div`
  color: ${({ theme }) => theme.colors.textCaption};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  text-align: right;
  max-width: 270px;

  @media screen and (max-width: ${MediaBreakPointUp.sm}) {
    max-width: 220px;
  }
`
